import commonConstant from '../../common/_commonConstant';

export const getMembershipPackage = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_MEMBERSHIP_PACKAGE_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_MEMBERSHIP_PACKAGE_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const createMembership = (state, action) => {
  switch (action.type) {
    case commonConstant.CREATE_MEMBERSHIP_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.CREATE_MEMBERSHIP_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const getMembershipDetail = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_MEMBERSHIP_DETAIL_PACKAGE_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_MEMBERSHIP_DETAIL_PACKAGE_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const updateMembership = (state, action) => {
  switch (action.type) {
    case commonConstant.UPDATE_MEMBERSHIP_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.UPDATE_MEMBERSHIP_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const getTenants = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_TENANT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_TENANT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const createTenant = (state, action) => {
  switch (action.type) {
    case commonConstant.CREATE_TENANT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.CREATE_TENANT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const updateTenant = (state, action) => {
  switch (action.type) {
    case commonConstant.UPDATE_TENANT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.UPDATE_TENANT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};
